import Cards from './Cards'
import RedirectMethods from './RedirectMethods'
import Sepa from './Sepa'

export default function SelectedMethod({
  flow,
  isLoading,
  currentMethod,
  unconfirmedOrder,
  errorsRef,
  ccFormButtonText,
  isAdventure,
}) {
  if(flow === 'redirect') {
    return (
      <RedirectMethods
        errorsRef={errorsRef}
        isLoading={isLoading}
        currentMethod={currentMethod}
        unconfirmedOrder={unconfirmedOrder}
      />
    )
  } else if(flow === 'sepa') {
    return (
      <Sepa
        errorsRef={errorsRef}
        isLoading={isLoading}
        buttonText={ccFormButtonText}
      />
    )
  }
  return (
    <Cards
      errorsRef={errorsRef}
      isLoading={isLoading}
      buttonText={ccFormButtonText}
      isAdventure={isAdventure}
    />
  )
}
